<template>
  <div class="d-flex container-analysis" :class="{ 'loading': isLoading}">
    <!-- Loading Overlay -->
    <div v-if="isLoading" class="loading-content">
      <div class="loading-spinner">
        <div class="ai-icon">
          <img src="@/assets/icon/ai.svg" alt="AI Processing" class="ai-loader-icon"/>
        </div>
      </div>
      <div class="loading-text">Analyzing vehicle damage...</div>
      <div v-if="false" class="loading-subtext">
        This usually takes 30-45 seconds
        <span v-if="timeRemaining > 0">
            <br>Estimated time remaining: {{ timeRemaining }} seconds
          </span>
      </div>
      <div class="progress-container">
        <div class="progress-bar">
          <div class="progress-bar-fill" :style="{ width: `${valueLoader}%` }"></div>
        </div>
        <div class="progress-percentage">{{ Math.min(Math.round(valueLoader), 100) }}%</div>
      </div>
    </div>

    <template v-if="damage">
      <div class="vehicle-block">
        <div class="d-flex">
          <div class="analysis-title">Vehicle Identification</div>
          <div class="analysis-title">AI Parts Inspect</div>
        </div>
        <div class="vehicle-block-info d-flex">
          <div class="vehicle-block-info-item">Make: <span>{{ vehicle.make }}</span></div>
          <div class="vehicle-block-info-item">Series: <span>{{ vehicle.series }}</span></div>
          <div class="vehicle-block-info-item">VIN: <span>{{ vehicle.VIN }}</span></div>
        </div>
        <div class="vehicle-block-info d-flex">
          <div class="vehicle-block-info-item">Model: <span>{{ vehicle.model }}</span></div>
          <div class="vehicle-block-info-item">Variant: <span>{{ vehicle.variant }}</span></div>
          <div class="vehicle-block-info-item">Body: <span>SUV</span></div>
        </div>
        <tabs ref="vehicle-identification-tabs">
          <tab name="Parts List" id="partsListVehicleIdentification" ref="photosDamagedParts">
            <div class="vehicle-block-table">
              <div class="vehicle-block-table-header">
                <div class="vehicle-block-table-header-item vehicle-block-table-header-description"
                     style="padding-left: 15px">Part Name
                </div>
                <div class="vehicle-block-table-header-item vehicle-block-table-header-qty">Qty</div>
                <div class="vehicle-block-table-header-item vehicle-block-table-header-condition">Condition</div>
                <div class="vehicle-block-table-header-item vehicle-block-table-header-severity">Severity</div>
                <div class="vehicle-block-table-header-item vehicle-block-table-header-action">Action</div>
                <div class="vehicle-block-table-header-item vehicle-block-table-header-notes">Notes</div>
                <div class="vehicle-block-table-header-item vehicle-block-table-header-image_id">Image ID</div>
                <div class="vehicle-block-table-header-item vehicle-block-table-header-quote_all">
                  <div style="padding-top: 5px;">Add to Quote</div>
                  <label class="form-check-inline checkbox">
                    <input class="form-check-input" type="checkbox" v-model="isCheckedAll" id="all-line-check">
                    <span class="icon clickable clickable-active"><i class='bx bx-check'></i></span>
                  </label>
                </div>
              </div>
              <template v-if="damageParts && damageParts.length">
                <div class="vehicle-block-table-body d-flex" v-for="(part, index) in damageParts" :key="index"
                     @contextmenu.prevent="editPart(part)">
                  <div class="vehicle-block-table-body-item vehicle-block-table-body-description" v-if="!part.create">{{
                      part.name
                    }}
                  </div>
                  <div class="vehicle-block-table-body-item vehicle-block-table-body-description" v-else>
                    <input :ref="'rfq-add-parts-list-part-name' + index"
                           v-model="part.name"
                           @keydown="onPressArrowKey(index, $event, 'name')"
                           @onEnter="addPart"
                           class="form-control tooltip-each-price-information-input font-weight-normal "
                           style="padding-left: 5px; padding-right: 5px; width:100%; display: inline-block;"/>
                    <i style="font-size: 24px;" @click="deletePart(index)"
                       class='bx bx-x-circle font-20  mr-2 remove-part ml-2'
                       v-b-tooltip.hover="{ customClass: 'ps-tooltip ps-tooltop--table', html: true, title: 'Remove', placement: 'leftbottom' }">
                    </i>
                  </div>
                  <div class="vehicle-block-table-body-item vehicle-block-table-body-qty" v-if="!part?.create">
                    {{ part.quantity }}
                  </div>
                  <div class="vehicle-block-table-body-item vehicle-block-table-body-qty" v-else>
                    <number-formatter
                        :ref="'rfq-add-parts-list-part-qty' + index"
                        v-model="part.quantity"
                        @onKeyDown="onPressArrowKey(index, $event, 'qty')"
                        @onEnter="addPart"
                        type="text"
                        class="form-control numeric"
                        format="0,0" style="width:40px">
                    </number-formatter>
                  </div>
                  <div class="vehicle-block-table-body-item vehicle-block-table-body-condition">{{
                      part.condition
                    }}
                  </div>
                  <div class="vehicle-block-table-body-item vehicle-block-table-body-severity">{{ part.severity }}</div>
                  <div class="vehicle-block-table-body-item vehicle-block-table-body-action">{{ part.action }}</div>
                  <div class="vehicle-block-table-body-item vehicle-block-table-body-notes">{{ part.notes }}</div>
                  <div class="vehicle-block-table-body-item vehicle-block-table-body-image_id">
                    {{ getImageName(part.image_id) }}
                  </div>
                  <div class="vehicle-block-table-body-item vehicle-block-table-body-quote_all">
                    <label class="form-check-inline checkbox">
                      <input v-model="part.selected" class="form-check-input" type="checkbox">
                      <span class="icon clickable clickable-active"><i class='bx bx-check'></i></span>
                    </label>
                  </div>
                </div>
              </template>
              <template>
                <div class="vehicle-block-table-body d-flex">
                  <div class="vehicle-block-table-body-item vehicle-block-table-body-description">
                    <a @click.prevent="addPart" href="#" class="add-part"
                       style="color: #29bbc1; padding-left: 60px; font-weight: 700; font-size: 13px;">
                      <i class='bx bx-plus'></i>
                      <span>Add Part</span>
                    </a>
                  </div>
                </div>
              </template>
            </div>
            <div class="d-flex" style="margin-top: 30px; float: right">
              <div class="analysis-btns d-flex">
                <div class="analysis-btn" style="margin-right: 20px">
                  <button class="btn btn-secondary" style="height: 41px" @click="$emit('cancel')">Cancel</button>
                </div>
                <div class="analysis-btn">
                  <button class="btn btn-primary" @click="addToQuote">Add To Quote</button>
                </div>
              </div>
            </div>
          </tab>
        </tabs>
      </div>
      <div class="damaged-block">
        <div>
          <div class="analysis-title" style="margin-bottom: 5px">Damaged Parts Assessment</div>
          <div class="wizard__divider"></div>
          <div class="analysis-subtitle" style="margin-bottom: 5px">Areas of damaged are indicated below and is subject
            to
            further inspection.
          </div>
        </div>
        <div>
          <svg-parts-viewer :selectedSchemeParts="partsForSvg" :body="typeBody"/>
        </div>
        <tabs ref="damaged-parts-tabs">
          <tab name="Photos" id="photosDamagedParts" ref="photosDamagedParts">
            <div style="overflow-y: auto; min-height: 400px" :style="{ maxHeight: heightPartsTable - 200 + 'px' }">
              <div v-for="(category, index) in damagePhotosByCategory" :key="index"
                   class="damaged-parts-tabs-photos-block">
                <div class="damaged-parts-tabs-title">{{ category.area }}</div>
                <div class="damaged-parts-tabs-photos">
                  <image-lightbox :isPreviewImage="true" :position="''" :imageList="getFilteredImages(category.images)"
                                  :pinnedImage="null"></image-lightbox>
                </div>
              </div>
            </div>
          </tab>
          <tab name="Electrical" id="electricalDamagedParts" ref="photosDamagedParts">
            <div>
              <div v-if="true">
                <div class="damaged-parts-tabs-title_table">Electrical Systems Check</div>
                <div class="vehicle-block-table">
                  <div class="vehicle-block-table-header vehicle-block-table-header-damaged">
                    <div class="vehicle-block-table-header-item vehicle-block-table-header-system_component">System
                      Component
                    </div>
                    <div class="vehicle-block-table-header-item vehicle-block-table-header-notes">Notes</div>
                    <div class="vehicle-block-table-header-item vehicle-block-table-header-image_id">Image ID</div>
                  </div>
                  <div class="vehicle-block-table-body vehicle-block-table-body-damaged d-flex"
                       v-for="(item, index) in damage.electrical_systems_check" :key="index">
                    <div class="vehicle-block-table-body-item vehicle-block-table-body-system_component">
                      {{ item?.system_component }}
                    </div>
                    <div class="vehicle-block-table-body-item vehicle-block-table-body-notes">{{ item?.notes }}</div>
                    <div class="vehicle-block-table-body-item vehicle-block-table-body-image_id">
                      {{ getImageName(item?.image_id) }}
                    </div>
                  </div>

                </div>

                <div class="damaged-parts-tabs-title_table" style="padding: 30px 0">Additional Notes:</div>
                <div class="damaged-parts-tabs-subtitle_table">{{
                    damage?.electrical_systems_check_additional_notes?.additional_notes || ''
                  }}
                </div>
              </div>
              <div v-else class="electrical-concerns">
                <div v-if="!electricalConcerns || !electricalConcerns.length" class="no-concerns">
                  No electrical concerns found.
                </div>
                <div v-else>
                  <div v-for="(concern, index) in electricalConcerns" :key="index" class="concern-item">
                    <h4 class="concern-title">{{ concern.system_component }}</h4>
                    <p class="concern-reason"><strong>Concern:</strong> {{ concern.reason_for_concerns }}</p>
                    <p class="concern-notes" v-html="formatNotes(concern.notes)"></p>
                  </div>
                </div>
              </div>
            </div>

          </tab>
          <tab name="Tyre/Rim" id="tyreRimDamagedParts" ref="photosDamagedParts">
            <div>
              <div v-if="true">
                <div class="damaged-parts-tabs-title_table">Tyre and Rim Condition Check</div>
                <div class="vehicle-block-table">
                  <div class="vehicle-block-table-header vehicle-block-table-header-damaged">
                    <div class="vehicle-block-table-header-item vehicle-block-table-header-system_component">System
                      Component
                    </div>
                    <div class="vehicle-block-table-header-item vehicle-block-table-header-notes">Notes</div>
                    <div class="vehicle-block-table-header-item vehicle-block-table-header-image_id">Image ID</div>
                  </div>
                  <div class="vehicle-block-table-body vehicle-block-table-body-damaged d-flex"
                       v-for="(item, index) in damage.tyre_rim_condition_check" :key="index">
                    <div class="vehicle-block-table-body-item vehicle-block-table-body-system_component">
                      {{ item?.system_component }}
                    </div>
                    <div class="vehicle-block-table-body-item vehicle-block-table-body-notes">{{ item?.notes }}</div>
                    <div class="vehicle-block-table-body-item vehicle-block-table-body-image_id">
                      {{ getImageName(item?.image_id) }}
                    </div>
                  </div>

                </div>

                <div class="damaged-parts-tabs-title_table" style="padding: 30px 0">Additional Notes:</div>
                <div class="damaged-parts-tabs-subtitle_table">{{
                    damage?.tyre_rim_condition_check_additional_notes?.additional_notes || ''
                  }}
                </div>
              </div>
              <div v-else class="tyre-rim-concerns">
                <div v-if="!tyreRimConcerns || !tyreRimConcerns.length" class="no-concerns">
                  No tyre/rim concerns found.
                </div>
                <div v-else>
                  <div v-for="(concern, index) in tyreRimConcerns" :key="index" class="concern-item">
                    <h4 class="concern-title">{{ concern.system_component }}</h4>
                    <p class="concern-reason"><strong>Condition:</strong> {{ concern.reason_for_concerns }}</p>
                    <p class="concern-notes" v-html="formatNotes(concern.notes)"></p>
                  </div>
                </div>
              </div>
            </div>
          </tab>
          <tab name="Mechanical System" id="MechanicalSystemCheck" ref="MechanicalSystemCheck">
            <div>
              <div v-if="true">
                <div class="damaged-parts-tabs-title_table">Mechanical System Check</div>
                <div class="vehicle-block-table">
                  <div class="vehicle-block-table-header vehicle-block-table-header-damaged">
                    <div class="vehicle-block-table-header-item vehicle-block-table-header-system_component">System
                      Component
                    </div>
                    <div class="vehicle-block-table-header-item vehicle-block-table-header-notes">Notes</div>
                    <div class="vehicle-block-table-header-item vehicle-block-table-header-image_id">Image ID</div>
                  </div>
                  <div class="vehicle-block-table-body vehicle-block-table-body-damaged d-flex"
                       v-for="(item, index) in damage.mechanical_condition_check" :key="index">
                    <div class="vehicle-block-table-body-item vehicle-block-table-body-system_component">
                      {{ item?.system_component }}
                    </div>
                    <div class="vehicle-block-table-body-item vehicle-block-table-body-notes">{{ item?.notes }}</div>
                    <div class="vehicle-block-table-body-item vehicle-block-table-body-image_id">
                      {{ getImageName(item?.image_id) }}
                    </div>
                  </div>
                </div>

                <div class="damaged-parts-tabs-title_table" style="padding: 30px 0">Additional Notes:</div>
                <div class="damaged-parts-tabs-subtitle_table">{{
                    damage?.mechanical_condition_check_condition_check_additional_notes?.additional_notes || ''
                  }}
                </div>
              </div>
              <div v-else class="tyre-rim-concerns">
                <div v-if="!mechanicalConcerns || !mechanicalConcerns.length" class="no-concerns">
                  No mechanical concerns found.
                </div>
                <div v-else>
                  <div v-for="(concern, index) in mechanicalConcerns" :key="index" class="concern-item">
                    <h4 class="concern-title">{{ concern.system_component }}</h4>
                    <p class="concern-reason"><strong>Condition:</strong> {{ concern.reason_for_concerns }}</p>
                    <p class="concern-notes" v-html="formatNotes(concern.notes)"></p>
                  </div>
                </div>
              </div>
            </div>
          </tab>
        </tabs>
      </div>
    </template>
  </div>
</template>
<script>
import Vue from 'vue'
import { isMobile } from 'mobile-device-detect'
import axios from 'axios'
import _ from 'lodash'
import SvgPartsViewer from './svg-parts-viewer.vue'
import ImageLightbox from '@/components/image-lightbox/image-lightbox.vue'
import NumberFormatter from '../../../components/utility/number-formatter.vue'

export default {
  name: 'rfq-analysis',
  props: {
    images: [],
    rfq: {},
    rfqVehicle: {}
  },
  components: {
    ImageLightbox,
    SvgPartsViewer,
    NumberFormatter,
  },
  data () {
    return {
      parts: [],
      damage: null,
      isLoading: false,
      isUnmounted: false,
      valueLoader: 0,
      maxLoader: 100,
      timeRemaining: 0,
      progressInterval: null,
      timeInterval: null,
      damageParts: [],
      heightPartsTable: 0,
    }
  },
  computed: {
    allParts () {
      return this.damageParts || []
    },
    isMobile () {
      return isMobile
    },
    typeBody () {
      const body = _.get(this.damage, 'vehicle.body')
      return _.isEmpty(_.trim(body)) ? 'HATCH' :
          _.toUpper(body) === 'SEDAN' ? 'SEDAN' : 'HATCH'
    },
    allImages () {
      if (!this.images || !this.damage?.assessment) return []

      // First, create an array of all image objects with their area and partName
      const allImageEntries = _.flatMap(this.damage.assessment, area =>
          _.chain(area.parts)
              .filter('image_id')
              .map(part => {
                const image = _.find(this.images, img => Number(img.id) === Number(part.image_id))
                return image ? { ...image, area: area.area, partName: part.name } : null
              })
              .compact()
              .value()
      )

      // Group by image id and merge the results
      return _(allImageEntries)
          .groupBy('id')
          .map(group => {
            const baseImage = _.omit(group[0], ['area', 'partName'])
            return {
              ...baseImage,
              areas: _.uniq(_.map(group, 'area')),
              partNames: _.uniq(_.map(group, 'partName'))
            }
          })
          .value()
    },
    vehicle () {
      // Return vehicle data with fallback to empty string for missing properties
      const vehicle = this.damage?.vehicle || {}
      const rfqVehicle = this.rfqVehicle || {}

      return {
        make: vehicle.make || rfqVehicle.make || '',
        series: vehicle.series || rfqVehicle.series || '',
        model: vehicle.model || rfqVehicle.model || '',
        variant: vehicle.variant || rfqVehicle.variant || '',
        VIN: vehicle.VIN || rfqVehicle.vin || rfqVehicle.VIN || '',
        // Add other vehicle properties as needed
      }
    },
    damagePhotosByCategory () {
      if (!this.damage?.assessment) return []

      return this.damage.assessment.map(area => ({
        area: area.area,
        images: [...new Set(area.parts
            .filter(part => part.image_id)
            .map(part => part.image_id)
        )]
      }))
    },
    partsForSvg () {
      if (_.isEmpty(this.damageParts)) return []
      return _.map(this.damageParts, 'area')
    },
    isCheckedAll: {
      get () {
        if (!this.damageParts || !this.damageParts.length) return false
        // Check if any part is not selected
        return this.damageParts.every(part => part.selected === true)
      },
      set (value) {
        this.toggleAllParts(value)
      }
    },

    electricalConcerns () {
      return this.damage?.electrical_systems_check || []
    },
    tyreRimConcerns () {
      return this.damage?.tyre_rim_condition_check || []
    },
    mechanicalConcerns () {
      return this.damage?.mechanical_condition_check || []
    },
    heightPartsListTable () {
      if (this.valueLoader >= 100) {
        this.heightPartsTable = document.querySelector('.vehicle-block-table').offsetHeight
      }
    },
  },
  methods: {
    /**
     * Handle arrow key navigation between part input fields
     * @param {number} index - Current part index
     * @param {KeyboardEvent} event - Keyboard event
     * @param {string} el - Current field name ('name', 'number', or 'qty')
     */
    onPressArrowKey (index, event, el) {
      if (event && event.code) {
        let refName = 'rfq-add-parts-list-part-'

        if (event.code == 'Enter') {
          this.addPart(index)
        }

        if (event.code == 'ArrowDown') {
          event.preventDefault()
          index = index + 1
          if (index >= this.damageParts.length) {
            index = 0
          }
          refName = refName + el + index
        } else if (event.code == 'ArrowUp') {
          event.preventDefault()
          index = index - 1
          if (index < 0) {
            index = this.damageParts.length - 1
          }
          refName = refName + el + index
        } else if (event.code == 'ArrowRight' || event.code == 'Tab') {
          if (event.code === 'Tab') {
            event.preventDefault()
          }

          if (el != 'qty') {
            var elem = event.srcElement
            let pos = this.getCaretPosition(elem)
            if (pos < elem.value.length) {
              return false
            }
          } else if (event.code === 'Tab') {
// Only prevent default for Tab on qty field, not for ArrowRight
            event.preventDefault()
          }

          if (el == 'name') {
            el = 'qty'
          } else if (el == 'qty') {
            el = 'name'
          }
          refName = refName + el + index
        } else if (event.code == 'ArrowLeft') {
          if (el != 'qty') {
            var elem = event.srcElement
            let pos = this.getCaretPosition(elem)
            if (pos > 0) {
              return false
            }
          }
          if (el == 'name') {
            el = 'qty'
          } else if (el == 'qty') {
            el = 'name'
          }
          refName = refName + el + index
        } else {
          return
        }

        if (this.$refs[refName] && this.$refs[refName][0]) {
          this.$refs[refName][0].focus()
        }
        event.preventDefault()
      }
    },

    /**
     * Get caret position in input field
     * @param {HTMLElement} ctrl - Input element
     * @returns {number} Caret position
     */
    getCaretPosition: function (ctrl) {
// IE < 9 Support
      if (document.selection) {
        ctrl.focus()
        var range = document.selection.createRange()
        var rangelen = range.text.length
        range.moveStart('character', -ctrl.value.length)
        var start = range.text.length - rangelen
        return start
      }
// IE >=9 and other browsers
      else if (ctrl.selectionStart || ctrl.selectionStart == '0') {
        return ctrl.selectionEnd
      } else {
        return 0
      }
    },
    focusPartInput (part, field) {
      const index = this.allParts.indexOf(part)
      if (index === -1) return

      const inputRef = `rfq-add-parts-list-part-${field}${index}`
      const inputElement = this.$refs[inputRef]
      if (inputElement && inputElement[0]) {
        inputElement[0].focus()
      }
    },
    deletePart (index) {
      this.damageParts.splice(index, 1)
    },
    editPart (part) {
      part.create = !part.create
    },
    givedamageParts () {
      if (!this.damage || !this.damage.assessment) return []
      // Create a new array to ensure reactivity
      return this.damage.assessment.flatMap((area, areaIndex) => {
        return area.parts.map((part, partIndex) => {

          // Ensure selected is always a boolean and reactive using $set
          if (!part.hasOwnProperty('selected')) {
            this.$set(this.damage.assessment[areaIndex].parts[partIndex], 'selected', false)
          }

          // Create a new object reference for each part to ensure reactivity
          const reactivePart = {
            ...part,
            severity: area.severity,
            area: area.area,
            areaIndex,
            partIndex,
            selected: this.damage.assessment[areaIndex].parts[partIndex].selected,
            create: false,
          }

          // Ensure the selected property remains reactive
          this.$set(reactivePart, 'selected', this.damage.assessment[areaIndex].parts[partIndex].selected)

          return reactivePart
        })
      })
    },
    addPart () {
      const part = {
        action: '',
        name: '',
        quantity: 1,
        selected: false,
        image_id: null,
        condition: '',
        note: '',
        create: true
      }
      this.damageParts.push(part)
      this.$nextTick(() => {
        this.focusPartInput(part, 'name')
      })
    },
    async checkAnswerAi (rfqId, aiQueueId, mounted = false) {
      const res = await axios.get(`/ir/repairer/rfq/${rfqId}/ai-parts-inspect/${aiQueueId}`)
      const data = res?.data
      const created = data?.created_at + 'z'
      const targetDate = new Date(created.replace(' ', 'T'))
      const now = new Date()
      const secondsPassed = Math.floor((now - targetDate) / 1000)
      if (!data?._status) {
        throw new Error('Error while checking answer ai for aiQueueId')
      }
      if (data?.status === 'processing' || data?.status === 'pending') {
        if (mounted) {
          this.valueLoader = Math.floor((secondsPassed / 60) * 100)
        }
        this.timeRemaining = this.timeRemaining + 5
        await new Promise((r) => setTimeout(r, 5 * 1000))
        return this.checkAnswerAi(rfqId, aiQueueId)
      }
      if (data?.status === 'completed') {
        return data
      }

    },
    async sendRequest (forced = false) {
      try {
        if (forced && this.damage) {
          this.damage = null
        }

        const damage = this.rfq?.AI?.damage
        if (damage && !forced) {
          this.damage = damage
          this.damageParts = this.givedamageParts()
          return
        }
        let rfqVehicle = this.rfqVehicle || {}
        let id = this.rfq?.id
        const aiQueueId = this.rfq?.AI?.aiQueueId
        const imageIds = this.images.map(img => img.id)
        //#827 Moved to backend
        // const saveVehicle = () => {
        //   axios.post('/ir/repairer/rfq/' + id, {
        //     vehicle: rfqVehicle,
        //   }).then((res) => {
        //     if (res.data._status) {
        //       if (!this.isUnmounted) {
        //         Vue.$toast.success('Vehicle details updated successfully')
        //         this.$emit('ai-res', this.damage)
        //       }
        //
        //     }
        //   })
        // }
        let response

        this.isLoading = true
        this.timeRemaining = 60
        this.valueLoader = 0
        // Update time remaining counter every second
        this.timeInterval = setInterval(() => {
          if (this.timeRemaining > 0) {
            this.timeRemaining--
          }
        }, 1000)
        // Simulate progress (slower, more realistic for 30-45s operation)
        this.progressInterval = setInterval(() => {
          if (this.valueLoader < 90) {
            // Slower progression that takes about 30-40 seconds to reach 90%
            this.valueLoader += (90 / this.timeRemaining) * (Math.random() * 0.2 + 0.9) // Random variation between 90-110% of average
          }
        }, 1000) // Update every second instead of 200ms

        if (!aiQueueId || forced) {
          const res1 = await axios.post(`/ir/repairer/rfq/${id}/ai-parts-inspect`, {
            imageIds: imageIds,
          })

          this.timeRemaining = res1.data?.remainTime || 45

          if (res1.data?._status) {
            //await new Promise((r) => setTimeout(r, Number(res1.data?.remainTime) * 1000))
            if (this.isUnmounted) return
            response = await this.checkAnswerAi(id, Number(res1.data?.aiQueueId))
          }

        } else {
          response = await this.checkAnswerAi(id, aiQueueId, true)
        }
        this.valueLoader = 100
        if (response && response?._status) {

          //#827 moved to backend
          // saveVehicle()
          if (!this.isUnmounted) {
            // Vue.$toast.success('Analysis completed successfully')
            this.damage = response?.damage
            if (this.damage?.vehicle) {
              rfqVehicle.make = this.damage?.vehicle.make
              rfqVehicle.vin = this.damage?.vehicle.VIN
              rfqVehicle.model = this.damage?.vehicle.model
              rfqVehicle.series = this.damage?.vehicle.series
              rfqVehicle.dom = this.damage?.vehicle.build_date
            }
            this.damageParts = this.givedamageParts()
          }

        } else {
          Vue.$toast.error(response?._msg || 'Failed to process images')
        }
      } catch (error) {
        console.error('Error sending images for analysis:', error)
        const errorMessage = error.response?.data?._msg || 'An error occurred while processing your request'
        Vue.$toast.error(errorMessage)
      } finally {
        clearInterval(this.progressInterval)
        clearInterval(this.timeInterval)
        if (!this.isUnmounted) {
          setTimeout(() => {
            this.isLoading = false
            this.timeRemaining = 0
          }, 500)
        }

      }
    },
    async addToQuote (callRef = false) {
      const selectedParts = (this.damageParts || [])
          .filter(p => p.selected)
          .map(p => ({ name: p.name, quantity: p.quantity || 1 }))

      if (selectedParts.length === 0) {
        if (!callRef) {
          this.$toast.warning('Please select at least one part to add to quote')
        }
        return false
      }

      try {
        const { data } = await axios.post(
            `/ir/repairer/rfq/${this.rfq?.id}/ai-parts-add`,
            { parts: selectedParts }
        )

        if (data && data._status) {
          this.$toast.success('Parts added to the RFQ successfully')
          this.$emit('added-to-quote', data)
          return data
        }
        const msg = data?._msg || 'Failed to add parts to quote'
        this.$toast.error(msg)
        throw new Error(msg)

      } catch (err) {
        const msg = err?.response?.data?._msg || err.message || 'Request failed'
        this.$toast.error(msg)
        throw err
      }
    },
    toggleAllParts (selected) {
      if (!_.get(this, 'damageParts')) return
      const updatedParts = _.map(this.damageParts, part =>
          _.assign({}, part, { selected: Boolean(selected) })
      )
      this.damageParts = updatedParts
    },
    togglePartSelection (part) {
      part.selected = !part.selected
    },
    getImageUrl (imageId) {
      const image = this.images.find(img => Number(img.id) === Number(imageId))
      return image ? image.previewH240 : ''
    },
    getImageName (imageId) {
      const image = this.images.find(img => Number(img.id) === Number(imageId))
      return image ? image.name : ''
    },
    formatNotes (notes) {
      return notes.replace(/\n/g, '<br>')
    },
    getFilteredImages (categoryImages) {
      return this.allImages.filter(img => categoryImages.includes(Number(img.id)))
    },
    updateFilteredImages (updatedImages, categoryImages) {
      // Since we're in read-only mode, we don't need to handle updates
      // But we keep the method to avoid warnings
    },
  },
  created () {

  },
  beforeDestroy () {
    this.isUnmounted = true
  },
  mounted () {
    // this.sendRequest()
  },
}
</script>
<style scoped>
.damaged-block >>> .tabs-component,
.vehicle-block >>> .tabs-component {
  position: static;
}

.damaged-block >>> .control-elem-1 {
  z-index: 999;
}

.container-analysis {
  padding: 15px;
  justify-content: center;
}

.container-analysis.loading {
  align-items: center;
  min-height: calc(100vh - 260px);
}

.vehicle-block {
  width: 65%;
}

.damaged-block {
  width: 35%;
  min-width: 350px;
  margin-left: 20px;
}

.analysis-title {
  font-size: 18px;
  font-weight: bold;
  line-height: 24px;
  color: #1C1F39;
  width: 50%;
}

.analysis-subtitle {
  font-size: 13px;
  font-weight: 600;
  line-height: 24px;
  margin-top: 10px;
}

.analysis-btns {
  position: relative;
  bottom: 10px;
}

.vehicle-block-info {
  font-size: 13px;
  font-weight: 600;
  margin-top: 10px;
}

.vehicle-block-info span {
  margin-left: 12px;
}

.vehicle-block-info-item {
  width: 33.333%;
}

.vehicle-block-table {
  overflow-y: hidden;
  overflow-x: auto;
}

.vehicle-block-table-header {
  height: 70px;
  width: 100%;
  background-color: rgba(27, 30, 56, .1) !important;
  color: #1c1f39 !important;
  font-size: 13px;
  font-weight: 700;
  line-height: 18px;
  display: flex;
  align-items: center;
  min-width: 850px;
}

.vehicle-block-table-body {
  min-height: 47px;
  border-bottom: 1px solid rgba(27, 30, 56, 0.25);
  color: #212529;
  font-size: 12px !important;
  line-height: 16px !important;
  letter-spacing: normal;
  font-weight: 500 !important;
  font-family: "Inter", sans-serif;
  min-width: 850px;
}

.vehicle-block-table-body:hover {
  background-color: #e5f6f5 !important;
}

.vehicle-block-table-header-item,
.vehicle-block-table-body-item {
  padding: .75rem;
}

.vehicle-block-table-header-description,
.vehicle-block-table-header-notes,
.vehicle-block-table-body-description,
.vehicle-block-table-body-notes {
  flex-grow: 1;
  min-width: 200px;
  width: 100%;
}

.vehicle-block-table-body-description {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  font-weight: 700;
}

.vehicle-block-table-header-qty,
.vehicle-block-table-body-qty {
  width: 40px;
  min-width: 40px;
  text-align: center;
}

.vehicle-block-table-header-quote_all,
.vehicle-block-table-body-quote_all {
  width: 70px;
}

.vehicle-block-table-header-condition,
.vehicle-block-table-body-condition {
  min-width: 80px;
}

.vehicle-block-table-header-action,
.vehicle-block-table-body-action {
  min-width: 65px;
}

.vehicle-block-table-header-severity,
.vehicle-block-table-header-image_id,
.vehicle-block-table-body-severity,
.vehicle-block-table-body-image_id {
  min-width: 100px;
}

.vehicle-block-table-body-image_id {
  color: rgb(0, 123, 255);
  overflow-wrap: break-word;
}

.vehicle-block-table-body-image_id:hover {
  color: #0056b3 !important;
}

label.checkbox > input[type="checkbox"] + span.icon i {
  background-color: #77afb9;
  height: 25px;
  width: 25px;
  border-radius: 3px;
}

.bx-check:before {
  color: white;
}

.damaged-parts-tabs-title,
.damaged-parts-tabs-title_table {
  font-size: 13px;
  font-weight: 600;
  line-height: 24px;
}

.damaged-parts-tabs-title_table {
  font-size: 15px;
  padding: 10px 0;
}

.damaged-parts-tabs-photos {
  width: 100%;
  border: 2px solid rgba(27, 30, 56, 0.25);
  border-radius: 3px;
  flex-wrap: wrap;
}

.damaged-parts-tabs-photos-item {
  width: 33.333%;
  padding: 3px;
}

.damaged-parts-tabs-photos-item-photo img {
  object-fit: cover;
  width: 100%;
}

.damaged-parts-tabs-photos-item-name {
  text-align: center;
  padding: 15px 0;
  color: rgb(0, 123, 255) !important;
}

.damaged-parts-tabs-photos-block {
  margin-top: 20px;
}

.damaged-parts-tabs-photos-block:first-child {
  margin-top: 0;
}

.electrical-concerns {
  padding: 20px;
}

.no-concerns {
  text-align: center;
  padding: 20px;
  font-size: 16px;
  font-weight: 600;
  color: #666;
}

.concern-item {
  margin-bottom: 20px;
  padding: 20px;
  border: 1px solid #ddd;
  border-radius: 5px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}

.concern-title {
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 10px;
}

.concern-reason {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 10px;
}

.concern-notes {
  font-size: 14px;
  color: #666;
}

.vehicle-block-table-header-system_component,
.vehicle-block-table-body-system_component {
  min-width: 100px;
}

.vehicle-block-table-body-system_component {
  font-weight: 700;
}

.vehicle-block-table-body-damaged {
  padding: 20px 0;
}

.vehicle-block-table-header-damaged,
.vehicle-block-table-body-damaged {
  min-width: 420px;
}

.damaged-parts-tabs-subtitle_table {
  font-size: 12px !important;
  line-height: 16px !important;
  letter-spacing: normal;
  font-weight: 500 !important;
}

.vehicle-block-table-body-damaged .vehicle-block-table-body-system_component,
.vehicle-block-table-body-damaged .vehicle-block-table-body-image_id {
  align-self: center;
}

.loading-overlay {
  /* position: absolute;
  top: 0;
  left: 0;
  background-color: rgba(255, 255, 255, 0.9);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 1;
  backdrop-filter: blur(2px); */
}

.loading-content {
  background: white;
  padding: 30px 40px;
  border-radius: 12px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
  text-align: center;
  max-width: 450px;
  width: 90%;
  height: fit-content;
  border: 1px solid #e9ecef;
}

.loading-spinner {
  margin-bottom: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.ai-icon {
  width: 80px;
  height: 80px;
  margin: 0 auto 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  animation: pulse 2s infinite;
}

.ai-loader-icon {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

@keyframes pulse {
  0% {
    transform: scale(1);
    opacity: 1;
  }

  50% {
    transform: scale(1.1);
    opacity: 0.8;
  }

  100% {
    transform: scale(1);
    opacity: 1;
  }
}

.progress-container {
  width: 100%;
  margin-top: 10px;
}

.progress-bar {
  height: 8px;
  background-color: #e9ecef;
  border-radius: 4px;
  overflow: hidden;
  margin-bottom: 8px;
  position: relative;
}

.progress-bar-fill {
  height: 100%;
  background: linear-gradient(90deg, #29BBC1, #1a9ea3);
  transition: width 0.8s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
}

.progress-bar-fill::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(90deg,
  transparent,
  rgba(255, 255, 255, 0.4),
  transparent);
  animation: shimmer 2s infinite;
}

.progress-percentage {
  font-size: 13px;
  color: #6c757d;
  text-align: right;
  font-weight: 500;
}

@keyframes shimmer {
  0% {
    transform: translateX(-100%);
  }

  100% {
    transform: translateX(100%);
  }
}
</style>

